import {
  Component,
  Input,
  ContentChildren,
  Renderer2,
  ElementRef,
  OnInit,
  Directive, QueryList, Output, EventEmitter, AfterViewInit, AfterContentInit
} from '@angular/core';


@Directive({selector: 'clo-button-option'})
export class CloButtonGroupOption {

  /**
   * The initial selection. If not assigned then the first button will be selected.
   */
  @Input() isActive: false;

  /**
   * The display string for the button
   */
  @Input() label: string;

  /**
   * This value is what is returned when the corresponding button is selected.
   */

  @Input() value: any;

  constructor() {

  }
}

/**
 * Buttons are used to make common actions immediately visible and easy to perform with one click, tap, or keypress.
 * Merchants can use them to navigate or to take action.
 *
 * It supports several button types.
 */
@Component({
  selector: 'clo-button-group',
  templateUrl: './button-group.html',
  styleUrls: ['./button-group.scss']
})
export class CloButtonGroup implements AfterContentInit {


  selectedValue: any;

  @ContentChildren(CloButtonGroupOption) options: QueryList<CloButtonGroupOption>;

  @Output() onSwitch = new EventEmitter();

  switch(value: any) {
    this.selectedValue = value;
    this.onSwitch.emit(value);
  }

  constructor(private _renderer: Renderer2, private _element: ElementRef) {
  }


  ngAfterContentInit(): void {
    const initialButton = this.options.find( item => item.isActive) || this.options.first;
    this.selectedValue = initialButton.value;
  }

}
